import type { AudioRecorderState } from "@/app/recsys/hooks/useAudioRecorder";

/**
 * Запуск встречи приходит ключом, а не флагом: флаг остаётся поднятым после
 * первой встречи, и вторая за ту же сессию вкладки не стартовала бы никогда.
 * Ключ меняется на каждую встречу, поэтому каждая получает ровно один запуск.
 */
export function shouldAutoStart(
  key: string | null | undefined,
  startedKey: string | null,
  state: AudioRecorderState,
): boolean {
  if (!key) return false;
  if (key === startedKey) return false;
  return state === "idle";
}

/**
 * Сорвавшийся запуск не должен запирать встречу навсегда: ключ тот же, а
 * попытка была неудачной, поэтому после ошибки рекордера отметка о запуске
 * снимается и та же встреча может стартовать снова.
 */
export function forgetFailedStart(state: AudioRecorderState): boolean {
  return state === "error";
}
